// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__13tid","unreadBadge":"styles_unreadBadge__8qscb","modalContent":"styles_modalContent__2v0G9","modal":"styles_modal__3Xo6I"};